<template>
    <div class="view view--events">
        <data-table
            class="has-margin-b45"
            v-bind:data="tableData"
            v-on:sort="sortDataTable"
        ></data-table>
    </div>
</template>

<script>
import { DataTable } from '@teamfurther/cinderblock';
import { snakeCase } from 'change-case';
import EventParticipantRepository from '../../repositories/EventParticipantRepository';
import router from '../../router';
import store from '../../store';
import MessageHandler from '../../messageHandler';

export default {
    components: {
        DataTable
    },
    data: function() {
        return {
            eventId: router.currentRoute.params.id,
            eventParticipantRepository: new EventParticipantRepository(),
            participants: [],
            tableData: {
                columnNames: {
                    name: this.__('Name'),
                    email: this.__('Email'),
                    appeared: this.__('Appeared')
                },
                items: [],
                sortableColumns: ['email', 'name']
            }
        };
    },
    methods: {
        getParticipants: async function(sort = '') {
            this.participants = await this.eventParticipantRepository.getParticipants(
                router.currentRoute.params.id,
                sort
            );
            let items = [];

            this.participants.forEach(participant => {
                items.push(this.transformParticipantData(participant));
            });

            this.$set(this.tableData, 'items', items);
            this.$nextTick(() => this.initUpdateParticipantEvent());
        },
        initUpdateParticipantEvent: function() {
            const vue = this;

            this.$el.querySelectorAll('.js-is-appeared').forEach(item => {
                item.removeEventListener('click', vue.updateParticipant);
                item.addEventListener('click', vue.updateParticipant);
            });
        },
        sortDataTable: function(sortByColumn) {
            if (sortByColumn.match(/^-/)) {
                this.getParticipants('-' + snakeCase(sortByColumn));
            } else {
                this.getParticipants(snakeCase(sortByColumn));
            }
        },
        transformParticipantData: function(participant) {
            let actions = [];

            const event = participant.events.find(
                event => event.id === +this.eventId
            );

            const appeared = event?.pivot.appeared ?? false;

            return {
                values: {
                    id: participant.id,
                    email: participant.email,
                    name: participant.name,
                    appeared: appeared
                        ? `<input type="checkbox" class="js-is-appeared" data-user-id="${event.pivot.user_id}" data-event-id="${event.pivot.event_id}" checked />`
                        : `<input type="checkbox" class="js-is-appeared" data-user-id="${event.pivot.user_id}" data-event-id="${event.pivot.event_id}" />`
                },
                actions: actions
            };
        },
        updateParticipant: async function(e) {
            const checkbox = e.target;
            const eventId = checkbox.getAttribute('data-event-id');
            const userId = checkbox.getAttribute('data-user-id');
            let appeared = false;

            if (checkbox.checked) {
                appeared = true;
            }

            await this.eventParticipantRepository.updateParticipant(
                eventId,
                userId,
                appeared
            );

            await this.getParticipants();

            store.state.alerts.push(
                new MessageHandler(
                    this.__('Participant was successfully updated.'),
                    this.__('Success.'),
                    'success'
                )
            );
        }
    },
    mounted: function() {
        this.getParticipants();
    }
};
</script>
